/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Forward_EmailInputs */

const en_dialog_forward_email = /** @type {(inputs: Dialog_Forward_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward an email`)
};

const es_dialog_forward_email = /** @type {(inputs: Dialog_Forward_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar un correo`)
};

/**
* | output |
* | --- |
* | "Forward an email" |
*
* @param {Dialog_Forward_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_forward_email = /** @type {((inputs?: Dialog_Forward_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Forward_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_forward_email(inputs)
	return en_dialog_forward_email(inputs)
});